import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Test1 from '../../assets/images/testimonial/testimonial-three-tab-img-1.png';
import Test3 from '../../assets/images/testimonial/testimonial-three-tab-img-3.png';
import Test2 from '../../assets/images/testimonial/testimonial-three-tab-img-2.png'

const Serviceslider = {
  autoplayspeed: 2500,
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: true,
  responsive: [
    {
      breakpoints: {
        1024: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        740: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    }
  ]
};

function TestimonialSix() {

  return (
    <div>
      <section className="testimonial-six">
        <div className="testimonial-six-shape-1" />
        <div className="testimonial-six-shape-2" />
        <div className="container">
          <div className="testimonial-six-title-box">
            <div
              className="section-three-title wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="section-three-title-title text-center">
                <h2>1253+ Customer Say About Us</h2>
              </div>
            </div>
            <div
              className="section-three-details text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <p>
                Digital marketing &amp; advertising approach focuses on capturing
                the essential
              </p>
            </div>
          </div>
          <Swiper className="swiper-wrapper" {...Serviceslider} slidesPerView={3} slidestoscroll={1} spaceBetween={30}>
            <SwiperSlide
              className="testimonial-six-single-box testimonial-six-single-box-one wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="testimonial-six-single-title-box">
                <div className="testimonial-six-single-title-img">
                  <img
                    src={Test1}
                    alt="testimonial-three-tab-img-1"
                  />
                </div>
                <div className="testimonial-six-single-title">
                  <h4>
                    Russell J. <span>/ CEO &amp; Founder</span>
                  </h4>
                </div>
              </div>
              <div className="testimonial-six-single-detail">
                <p>
                  " On the other hand denounce with righteou indignation and
                  dislike men beguiled and demoralized "
                </p>
              </div>
              <div className="star-icon">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="testimonial-six-single-box testimonial-six-single-box-two wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <div className="testimonial-six-single-title-box">
                <div className="testimonial-six-single-title-img">
                  <img
                    src={Test3}
                    alt="testimonial-three-tab-img-3"
                  />
                </div>
                <div className="testimonial-six-single-title">
                  <h4>
                    Somalia <span>/ Developer</span>
                  </h4>
                </div>
              </div>
              <div className="testimonial-six-single-detail">
                <p>
                  " On the other hand denounce with righteou indignation and
                  dislike men beguiled and demoralized "
                </p>
              </div>
              <div className="star-icon">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="testimonial-six-single-box testimonial-six-single-box-three wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="500ms"
            >
              <div className="testimonial-six-single-title-box">
                <div className="testimonial-six-single-title-img">
                  <img
                    src={Test2}
                    alt="testimonial-three-tab-img-2"
                  />
                </div>
                <div className="testimonial-six-single-title">
                  <h4>
                    Michel H. <span>/ Businessman</span>
                  </h4>
                </div>
              </div>
              <div className="testimonial-six-single-detail">
                <p>
                  " On the other hand denounce with righteou indignation and
                  dislike men beguiled and demoralized "
                </p>
              </div>
              <div className="star-icon">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="testimonial-six-single-box testimonial-six-single-box-one wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="700ms"
            >
              <div className="testimonial-six-single-title-box">
                <div className="testimonial-six-single-title-img">
                  <img
                    src={Test1}
                    alt="testimonial-three-tab-img-1"
                  />
                </div>
                <div className="testimonial-six-single-title">
                  <h4>
                    Russell J. <span>/ CEO &amp; Founder</span>
                  </h4>
                </div>
              </div>
              <div className="testimonial-six-single-detail">
                <p>
                  " On the other hand denounce with righteou indignation and
                  dislike men beguiled and demoralized "
                </p>
              </div>
              <div className="star-icon">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="testimonial-six-single-box testimonial-six-single-box-two wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="900ms"
            >
              <div className="testimonial-six-single-title-box">
                <div className="testimonial-six-single-title-img">
                  <img
                    src={Test3}
                    alt="testimonial-three-tab-img-3"
                  />
                </div>
                <div className="testimonial-six-single-title">
                  <h4>
                    Somalia <span>/ Developer</span>
                  </h4>
                </div>
              </div>
              <div className="testimonial-six-single-detail">
                <p>
                  " On the other hand denounce with righteou indignation and
                  dislike men beguiled and demoralized "
                </p>
              </div>
              <div className="star-icon">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="testimonial-six-single-box testimonial-six-single-box-three wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="1100ms"
            >
              <div className="testimonial-six-single-title-box">
                <div className="testimonial-six-single-title-img">
                  <img
                    src={Test2}
                    alt="testimonial-three-tab-img-2"
                  />
                </div>
                <div className="testimonial-six-single-title">
                  <h4>
                    Michel H. <span>/ Businessman</span>
                  </h4>
                </div>
              </div>
              <div className="testimonial-six-single-detail">
                <p>
                  " On the other hand denounce with righteou indignation and
                  dislike men beguiled and demoralized "
                </p>
              </div>
              <div className="star-icon">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </div>
  );
}

export default TestimonialSix;
